module.exports = __webpack_public_path__ + "img/508.26943c90.jpg";